import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Typography } from 'antd';

import { OfferType } from 'entities/Offer/ui/OfferType/OfferType';
import { CategoryEnum, TaskContractorRead } from 'shared/api/client/codegen.api';
import { CATEGORIES } from 'shared/consts/categories';
import { STATUSES } from 'shared/consts/statuses';
import { BadgeStatus, Text } from 'shared/ui';

interface ITaskHeaderProps extends HTMLAttributes<HTMLDivElement> {
	name?: string;
	type?: string;
	category?: CategoryEnum;
	contractor?: TaskContractorRead;
	status?: string;
}

export const OfferHeader: FC<ITaskHeaderProps> = ({
	className,
	contractor,
	name = '',
	status,
	type,
	category,
	...props
}) => {
	const { t } = useTranslation();

	return (
		<Flex {...props} className={className} vertical gap={8} style={{ width: '100%' }}>
			<Flex gap={7} align="center">
				<OfferType isPublic={type === 'public'} />
				<Flex gap={4}>
					<Text type="secondary">• {CATEGORIES[category as keyof typeof CATEGORIES]}</Text>
				</Flex>
			</Flex>
			<Flex align="center" justify="space-between">
				<Typography.Title style={{ margin: 0 }} level={3}>
					{contractor ? `${t('Proposal for')} @${contractor.username}` : name}
				</Typography.Title>
				{!!status && <BadgeStatus status={status as keyof typeof STATUSES} />}
			</Flex>
		</Flex>
	);
};
